import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useThemeMode } from '../components/ThemeModeContext';
import AppStarLogo from '../images/appstar_title_tr.png';
import Copyright from '../components/Copyright';

export default function TermsOfService() {
  const navigate = useNavigate();
  const { isDarkMode, clearOverride } = useThemeMode();

  useEffect(() => {
    clearOverride();
    window.scrollTo(0, 0);
  }, [clearOverride]);

  return (
    <div style={{
      minHeight: '100vh',
      background: isDarkMode ? '#121212' : '#f1f5f9',
      color: isDarkMode ? '#f1f5f9' : '#0f172a',
      padding: '2rem 1rem'
    }}>
      <div style={{ maxWidth: 800, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <img src={AppStarLogo} alt="AppStar Logo" style={{ width: 100, marginBottom: 12 }} />
          <h1 style={{ fontSize: '2rem', fontWeight: 700, margin: 0 }}>AppStar Terms of Service</h1>
          <p style={{ opacity: 0.7, marginTop: '0.5rem' }}>Last updated: November 2025</p>
        </div>

        <div style={{ lineHeight: 1.7 }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            1. Acceptance of Terms
          </h2>
          <p>
            By accessing or using AppStar, you agree to be bound by these Terms of Service. If you do not agree, 
            you must not use AppStar.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            2. Eligibility
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li>You must be at least 13 years old to use AppStar.</li>
            <li>If you are under the age of majority in your jurisdiction, you must have parental or guardian consent.</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            3. User Responsibilities
          </h2>
          <p>When using AppStar, you agree to:</p>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li>Provide accurate information when required.</li>
            <li>Not include personal or sensitive information (e.g., passwords, phone numbers, financial details) 
            in your apps.</li>
            <li>Respect the rights of others and comply with applicable laws.</li>
            <li>Accept full responsibility for the content you create, publish, or share.</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            4. Public vs. Private Apps
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li>Apps you build are visible to you by default.</li>
            <li>If you choose to make your app Public, it may be visible to other AppStar users.</li>
            <li>Public apps may also be published on a webserver, making them accessible worldwide.</li>
            <li><strong>Warning:</strong> Do not include private information in apps you make Public.</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            5. Intellectual Property
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li>AppStar and its services are owned and operated by AppStar.</li>
            <li>You may not use AppStar to recreate or distribute proprietary, copyrighted, trademarked, 
            or patented software.</li>
            <li>You may not use names, logos, or marks that infringe on intellectual property rights.</li>
            <li>You retain ownership of the apps you create, but by making them Public, you grant AppStar 
            a non-exclusive license to display and share them within the platform.</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            6. Prohibited Conduct
          </h2>
          <p>You agree not to:</p>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li>Use AppStar for illegal, harmful, or abusive purposes.</li>
            <li>Attempt to reverse engineer, hack, or disrupt AppStar's services.</li>
            <li>Upload or share malicious code, viruses, or harmful software.</li>
            <li>Violate the intellectual property rights of others.</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            7. Data Use & AI Providers
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li>AppStar collects limited data for security and quality assurance purposes.</li>
            <li>AppStar does not use your data to train AI models.</li>
            <li>However, AppStar relies on third-party AI providers (e.g., OpenAI), and we cannot guarantee 
            whether those providers use submitted data for training.</li>
            <li>Do not input private or proprietary data that you would not want potentially used by external AI providers.</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            8. Indemnification
          </h2>
          <p>You agree to indemnify, defend, and hold harmless AppStar, its affiliates, and employees from any claims, 
          damages, or legal actions arising from:</p>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li>Your misuse of AppStar.</li>
            <li>Intellectual property violations.</li>
            <li>Any apps you create, publish, or share.</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            9. Limitation of Liability
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li>AppStar is provided "as is" without warranties of any kind.</li>
            <li>AppStar is not liable for any damages, losses, or claims resulting from your use of the app, 
            including but not limited to data loss, exposure of private information, or third-party legal actions.</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            10. Termination
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li>AppStar reserves the right to suspend or terminate your account at any time for violation of these Terms.</li>
            <li>You may stop using AppStar at any time.</li>
          </ul>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            11. Changes to Terms
          </h2>
          <p>
            We may update these Terms of Service from time to time. Updates will be posted within the app, and continued 
            use of AppStar after changes indicates your acceptance of the revised terms.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            12. Governing Law
          </h2>
          <p>
            These Terms are governed by the laws of Australia. Any disputes will be resolved in the courts 
            of that jurisdiction.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>
            13. Contact
          </h2>
          <p>
            For questions about these Terms of Service, please contact:{' '}
            <a href="mailto:appstar@zylascope.com" style={{ color: '#6366f1', textDecoration: 'underline' }}>
              appstar@zylascope.com
            </a>
          </p>
        </div>

        <div style={{ textAlign: 'center', marginTop: '3rem', marginBottom: '2rem' }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              padding: '0.75rem 2rem',
              background: 'var(--dark-blue)',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              fontSize: '1rem',
              fontWeight: 700,
              cursor: 'pointer',
              boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
            }}
          >
            Sign Up
          </button>
        </div>
        
        <Copyright sx={{ mt: 5, mb: 2 }} />
      </div>
    </div>
  );
}
